module.exports = __webpack_public_path__ + "img/online_school_boy.a241ba98.png";